import Image from "next/image";
import Remote, { Blur } from "../../LoaderRemote";
import dynamic from "next/dynamic";
import { useTranslation } from "../../../context/TranslationContext.js";
const Fancybox = dynamic(() => import("../../Fancybox.js"));
const Content = ({ styles, Images, page }) => {
  const { morePhotos } = useTranslation();
  const CoverPhotos = Images.slice(0, 4),
    PhotosWithoutCover = Images.slice(4, Images.length);

  return (
    <>
      <div className={styles.Photos}>
        {CoverPhotos.map((item, key) => (
          <Fancybox options={{ infinite: false }} key={item.uploadID}>
            <div
              className="w-full h-full relative"
              data-fancybox="gallery"
              data-src={
                process.env.NEXT_PUBLIC_CDN + "/uploads/" + item.Filename
              }
              data-thumb={
                process.env.NEXT_PUBLIC_CDN + "/uploads/150/" + item.Filename
              }
            >
              <Image
                className="cursor-pointer"
                src={item.Filename}
                objectFit={"cover"}
                objectPosition={"center"}
                layout="fill"
                alt={item.aciklama}
                sizes={
                  key == 0
                    ? `
                (max-width: 1024px) 30vw,
                60vw`
                    : `
                    (max-width: 1024px) 15vw,
                    30vw`
                }
                loader={Remote}
                priority={key == 0 ? 1 : 0}
              />
              {key == CoverPhotos.length - 1 && (
                <div className="hidden lg:flex justify-center items-center absolute inset-0 bg-black bg-opacity-50 pointer-events-none">
                  <span className="font-semibold text-xl text-white">
                    +{Images.length - CoverPhotos.length} {morePhotos}
                  </span>
                </div>
              )}
            </div>
          </Fancybox>
        ))}
      </div>
      <div className="hidden">
        {PhotosWithoutCover.map((i, k) => {
          return (
            <button
              key={k}
              data-fancybox="gallery"
              data-src={process.env.NEXT_PUBLIC_CDN + "/uploads/" + i.Filename}
              data-thumb={
                process.env.NEXT_PUBLIC_CDN + "/uploads/150/" + i.Filename
              }
            ></button>
          );
        })}
      </div>
    </>
  );
};

export default Content;
